declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    configs: { [key: string]: any };
  }
}
window.configs = window.configs || {};

export default function getEnv(name: string) {
  return window?.configs?.[name] || process.env[name];
}

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
};

export const formatNumber = (value: number) => {
  if (!value) return value;
  return value.toLocaleString("en-US");
};

export const formatDateStringFromNum = (days: number) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString().substring(0, 10);
};

export const formatDateString = (dateString: string) => {
  const date = new Date(dateString);
  return (
    (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) +
    "/" +
    (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
    "/" +
    date.getFullYear()
  );
};

export const formatDateStringFromDate = (longDate: Date | null) => {
  if (!longDate) return longDate;
  const date = new Date(longDate);
  return (
    (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) +
    "/" +
    (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
    "/" +
    date.getFullYear()
  );
};

export const formatCurrency = (value: number) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
};
